import { IntlShape } from "react-intl";
import { toast } from "react-toastify";
import { IErrorResponse } from "../interfaces";

export const handleServerError = (response: IErrorResponse, intl: IntlShape) => {

  // If 400 Bad Request, replace the field names using the intl messages for better user readability.
  if (response?.status && response.status === 400) {
    const words = response?.data?.error?.message.split(" ") || [];
    const readableMessage = words.map(word => {
      const key = 'risksAndIssues.formLabels.' + lowerCaseFirstLetter(word);
      return key in intl.messages ? intl.formatMessage({ id: key }) : word;
    }).join(" ");
    toast.error(intl.formatMessage({ id: "general.validationError" }, { message: readableMessage }));
  } else {
    toast.error(intl.formatMessage({ id: "general.toastSomethingWentWrong" }));
  }
};

const lowerCaseFirstLetter = (str: string) => str.charAt(0).toLowerCase() + str.slice(1);